import Parse from "parse";

export interface PageAttributes {
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  tenant: Parse.Object;
  slug: string;
  route: string;

  title_de?: string;
  title_en?: string;
  description_de?: string;

  // HTML-Inhalt der Seite (einfaches System)
  html_de?: string;
  html_en?: string;

  layout?: "default" | "fullwidth" | "sidebar" | "tabs";
  showInMenu?: boolean;
  menuOrder?: number;
  menuIcon?: string;

  metaTitle?: string;
  metaDescription?: string;

  isActive?: boolean;
}

export class Page extends Parse.Object<PageAttributes> {
  static className = "APP_Page";

  constructor(data?: Partial<PageAttributes>) {
    super("APP_Page", data as PageAttributes);
  }

  get slug(): string {
    return this.get("slug") || "";
  }

  get route(): string {
    return this.get("route") || "";
  }

  get title_de(): string | undefined {
    return this.get("title_de");
  }

  get title_en(): string | undefined {
    return this.get("title_en");
  }

  get description_de(): string | undefined {
    return this.get("description_de");
  }

  get layout(): string {
    return this.get("layout") || "default";
  }

  get showInMenu(): boolean {
    return this.get("showInMenu") ?? true;
  }

  get menuOrder(): number {
    return this.get("menuOrder") ?? 0;
  }

  get menuIcon(): string | undefined {
    return this.get("menuIcon");
  }

  get isActive(): boolean {
    return this.get("isActive") ?? true;
  }
}

Parse.Object.registerSubclass("APP_Page", Page);
